/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import clsx from 'clsx';

import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';

import MainMenuItems from './MainMenuItems';
import { useLocation } from "react-router-dom";
import AppMenuItems from "./AppMenuItems";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)'
    },
    drawerPaper: {
        ...theme.custom.apiOverviewPage.leftMenu.styles,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(0),
        },
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    listPadding: {
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingTop: '0',
        paddingBottom: '0',
    },
    drawerComponent: {
        width: 'inherit',
        height: '110px',
        opacity: '0.2'
    },
}));

interface MainMenuDrawerProps {
    menuDrawerOpen: boolean,
    organizationHandle: string,
}

function MainMenuDrawer(props: MainMenuDrawerProps) {
    const { menuDrawerOpen, organizationHandle } = props;
    const classes = useStyles();
    const location = useLocation();
    const currentPath = location.pathname;
    const artifact = currentPath.split('/')[2];

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !menuDrawerOpen && classes.drawerPaperClose),
                }}
                open={menuDrawerOpen}
            >
                <div className={classes.drawerComponent} />
                <List className={classes.listPadding}>
                    {artifact === 'applications' ? <AppMenuItems /> :
                        <MainMenuItems organizationHandle={organizationHandle} />}
                </List>
            </Drawer>
        </div>
    );
}

export default MainMenuDrawer;
